export default __webpack_public_path__ + "static/cic-bbba98ccc43f92b7f4194c8fbb57d71c.png";